import LegalPage from "./legalPage";
import { useTranslation } from "../../../../i18n/useTranslation";

const Privacy = () => {
  const { t } = useTranslation();
  return <LegalPage title={t("legalPrivacy.title")} sections={t("legalPrivacy.sections")} />;
};

export default Privacy;
